var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8PlaceMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aPlaceMarker{fill:#b30200;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aPlaceMarker",
    d: "M12,1A6,6,0,0,0,6,7c0,4.286,6,11,6,11s6-6.714,6-11A6,6,0,0,0,12,1Zm0,2a4,4,0,0,1,4,4c0,2.01-2.081,5.36-4,7.859C10.077,12.364,8,9.016,8,7A4,4,0,0,1,12,3Zm0,2a2,2,0,1,0,2,2A2,2,0,0,0,12,5ZM7.48,15.436C4.231,16.1,2,17.442,2,19c0,2.209,4.477,4,10,4s10-1.791,10-4c0-1.558-2.231-2.9-5.48-3.564-.452.661-.895,1.267-1.3,1.8,2.732.414,4.349,1.28,4.732,1.766-.515.654-3.253,2-7.947,2l0,0,0,0C7.3,21,4.567,19.655,4.051,19c.383-.487,2-1.355,4.732-1.768C8.375,16.7,7.932,16.1,7.48,15.436Z",
    transform: "translate(-2 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PlaceMarker);
export default __webpack_public_path__ + "static/media/icons8-place_marker.793eb2668dd7dbea9a277ddf8653fd8f.svg";
export { ForwardRef as ReactComponent };